import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

import RedirectPageRoute from "~/pages/RedirectPageRoute";

const LayoutNoSidebarLandlordInvoices = lazy(
  () =>
    import(
      "~/pages/providerWrapped/private/noSidebar/landlord/invoices/LayoutInvoices"
    )
);
const LayoutNoSidebarTenantInvoices = lazy(
  () =>
    import(
      "~/pages/providerWrapped/private/noSidebar/tenant/invoices/LayoutInvoices"
    )
);

// Lazy load invoice pages
const PageNoSidebarLandlordSpecificInvoice = lazy(
  () =>
    import(
      "~/pages/providerWrapped/private/noSidebar/landlord/invoices/PageSpecificInvoice"
    )
);
const PageNoSidebarTenantSpecificInvoice = lazy(
  () =>
    import(
      "~/pages/providerWrapped/private/noSidebar/tenant/invoices/PageSpecificInvoice"
    )
);

export const invoiceRoutes: RouteObject[] = [
  // Landlord Invoice Routes (No Sidebar)
  {
    path: "/landlord/invoices",
    Component: LayoutNoSidebarLandlordInvoices,
    children: [
      {
        index: true,
        // Nothing to see here. Send backwards.
        element: <RedirectPageRoute to="/landlord/transactions" />,
      },
      {
        path: ":invoiceId",
        Component: PageNoSidebarLandlordSpecificInvoice,
      },
    ],
  },

  // Tenant Invoice Routes (No Sidebar)
  {
    path: "/tenant/invoices",
    Component: LayoutNoSidebarTenantInvoices,
    children: [
      {
        index: true,
        // allow-redirect=true signals that this was a programmic redirect.
        // The user did not navigate to this page themselves.
        // So we are able to redirect them away if needed.
        element: <RedirectPageRoute to="/tenant/leases?allow-redirect=true" />,
      },
      {
        path: ":invoiceId",
        Component: PageNoSidebarTenantSpecificInvoice,
      },
    ],
  },
];
